import request, { authOptions } from 'api/requestUtils'

/**
 * Leaf API helper for fetching an encoded Zendesk ticket id.
 * Kept out of api/zendesk so zendeskUtils can call it without the api/zendesk ↔ zendeskUtils cycle.
 */
export async function getEncodedZendeskTicketId(
  ticketId: string,
): Promise<string | null> {
  try {
    const response = await request.get<{ result: { encodedId: string } }>(
      `/api/zendesk/ticket/${ticketId}`,
      authOptions(),
    )
    return response.result.encodedId || null
  } catch(error) {
    console.error('Error fetching Zendesk ticket:', error)
    return null
  }
}
